// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

/* Overlay con velo blanco translúcido (como antes) */
.cube-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff88; /* <- vuelve el velo */
  z-index: 1000;
  overflow: hidden;
  pointer-events: none;        /* no bloquea taps/scroll */
  contain: layout paint;       /* aisla repaints */
}

/* Cubo con sombra (efecto intacto) */
.cube {
  background-color: #ffffff;
  box-shadow: 0 0 15px rgba(0,0,0,0.5);
  position: absolute;
  width: 100vw;
  height: 100vh;
  transform-origin: center;
  will-change: transform, opacity;
  backface-visibility: hidden;
}

.top-left { top: 0; left: 0; }
.top-right { top: 0; right: 0; }
.bottom-left { bottom: 0; left: 0; }
.bottom-right { bottom: 0; right: 0; }

/* Contenido principal: SIEMPRE visible (no lo opaques) */
.animated-page {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 10;
  background-color: transparent;
  opacity: 1;                 /* <- no lo retrasamos */
}

/* Si todavía usás .fade-in en otros lados, dejalo así */
.fade-in {
  opacity: 1;
  transition: opacity 1.5s ease-in-out;
}
`, "",{"version":3,"sources":["webpack://./src/styles/AnimatedPage.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA,qDAAqD;AACrD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B,EAAE,sBAAsB;EACnD,aAAa;EACb,gBAAgB;EAChB,oBAAoB,SAAS,2BAA2B;EACxD,qBAAqB,QAAQ,mBAAmB;AAClD;;AAEA,qCAAqC;AACrC;EACE,yBAAyB;EACzB,oCAAoC;EACpC,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,wBAAwB;EACxB,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA,YAAY,MAAM,EAAE,OAAO,EAAE;AAC7B,aAAa,MAAM,EAAE,QAAQ,EAAE;AAC/B,eAAe,SAAS,EAAE,OAAO,EAAE;AACnC,gBAAgB,SAAS,EAAE,QAAQ,EAAE;;AAErC,yDAAyD;AACzD;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,6BAA6B;EAC7B,UAAU,kBAAkB,wBAAwB;AACtD;;AAEA,wDAAwD;AACxD;EACE,UAAU;EACV,oCAAoC;AACtC","sourcesContent":[".page-container {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\n/* Overlay con velo blanco translúcido (como antes) */\n.cube-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #ffffff88; /* <- vuelve el velo */\n  z-index: 1000;\n  overflow: hidden;\n  pointer-events: none;        /* no bloquea taps/scroll */\n  contain: layout paint;       /* aisla repaints */\n}\n\n/* Cubo con sombra (efecto intacto) */\n.cube {\n  background-color: #ffffff;\n  box-shadow: 0 0 15px rgba(0,0,0,0.5);\n  position: absolute;\n  width: 100vw;\n  height: 100vh;\n  transform-origin: center;\n  will-change: transform, opacity;\n  backface-visibility: hidden;\n}\n\n.top-left { top: 0; left: 0; }\n.top-right { top: 0; right: 0; }\n.bottom-left { bottom: 0; left: 0; }\n.bottom-right { bottom: 0; right: 0; }\n\n/* Contenido principal: SIEMPRE visible (no lo opaques) */\n.animated-page {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  z-index: 10;\n  background-color: transparent;\n  opacity: 1;                 /* <- no lo retrasamos */\n}\n\n/* Si todavía usás .fade-in en otros lados, dejalo así */\n.fade-in {\n  opacity: 1;\n  transition: opacity 1.5s ease-in-out;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
